import * as React from 'react';
import {useTranslation} from 'react-i18next';
import type {CreateOptionProps} from './types';

function DefaultCreateOption({
  inputValue,
  onCreate,
  formatCreateLabel,
}: CreateOptionProps) {
  const {t} = useTranslation();
  return (
    <button
      type="button"
      onClick={onCreate}
      className="flex w-full items-center justify-start border-0 border-t border-[#f2f4f8] bg-white px-4 py-[16px] text-left text-[16px] font-medium leading-5 text-[var(--chekin-color-brand-blue)] outline-none hover:bg-[var(--chekin-color-surface-pressed)]"
    >
      {formatCreateLabel
        ? formatCreateLabel(inputValue)
        : t('create_option', {input: inputValue})}
    </button>
  );
}

export {DefaultCreateOption};
